import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdViewList, MdList, MdTrendingUp } from 'react-icons/md';
import ProductsOverview from './ProductsOverview';
import PerformanceInsights from '../Items/PerformanceInsights';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import TabBar from '../../../shared/layout/tabs/TabBar';
import TabButton from '../../../shared/layout/tabs/TabButton';

const Products = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('overview');

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle icon={<MdViewList size={28} />}>{t('Products.title')}</PageTitle>
            </PageHeader>

            <PageContent>
                <TabBar>
                    <TabButton
                        active={activeTab === 'overview'}
                        onClick={() => setActiveTab('overview')}
                        icon={<MdList />}
                    >
                        {t('Products.overview')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'performance'}
                        onClick={() => setActiveTab('performance')}
                        icon={<MdTrendingUp />}
                    >
                        {t('Products.performance_insights')}
                    </TabButton>
                </TabBar>

                <div style={{ marginTop: '24px' }}>
                    {activeTab === 'overview' && <ProductsOverview />}
                    {activeTab === 'performance' && <PerformanceInsights />}
                </div>
            </PageContent>
        </PageContainer>
    );
};

export default Products;
